import styled from 'styled-components'
import Text from '../atoms/Text'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
 // 모바일에서 터치 시 발생하는 파란색 하이라이트 제거 
 -webkit-tap-highlight-color: transparent;
`
const StatusDot = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  outline: ${({ $isActive, theme }) =>
   $isActive ? `3px solid ${theme.colors.secondary}` : 'none'};
  background-color: ${({ $color }) => $color};
`

const WeekdayDot = ({ count, dayIndex, isActive, onClick }) => {
  const WEEKDAYS = ['월', '화', '수', '목', '금', '토', '일']
  const getColor = (count) => {
    if (count === 0) return '#EEEEEE'
    if (count === 1) return '#EAF7EE'
    if (count === 2) return '#CFF1D9'
    if (count === 3) return '#9BE5AE'
    return '#6FDC8A'
  }

  return (
    <Wrapper onClick={onClick}>
      <StatusDot $count={count} $isActive={isActive} $color={getColor(count)}/>
      <Text 
        variant="caption"
        weight={isActive ? 'bold' :'medium'}
        color={isActive ? 'accent' :'alternative'}>{WEEKDAYS[dayIndex]}</Text>
    </Wrapper>
  )
}

export default WeekdayDot
